/* eslint-disable camelcase */

import fuelType from './fuelType'
import carFueling from './carFueling'
import fuelConsumption from './fuelConsumption'

export default {
  namespaced: true,
  modules: {
    fuelType,
    carFueling,
    fuelConsumption
  }
}
